"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletConnection = exports.ConnectedWalletAccount = void 0;
var wallet_account_1 = require("@near-js/wallet-account");
Object.defineProperty(exports, "ConnectedWalletAccount", { enumerable: true, get: function () { return wallet_account_1.ConnectedWalletAccount; } });
Object.defineProperty(exports, "WalletConnection", { enumerable: true, get: function () { return wallet_account_1.WalletConnection; } });
